import React from 'react'

const demoStorageKeys = [
  'alco-log-drivers-v1',
  'alco-log-vehicles-v1',
  'alco-log-records-v4',
  'alco-log-settings-v4',
]

export default class AppErrorBoundary extends React.Component {
  state = { hasError: false }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error) {
    console.error('ALCO LOG could not render', error)
  }

  resetDemoData = () => {
    const confirmed = window.confirm('この端末の体験モードデータを初期化して再読み込みしますか？')
    if (!confirmed) return
    try {
      demoStorageKeys.forEach((key) => window.localStorage.removeItem(key))
    } catch {
      // Safariで保存領域自体が拒否されていても再読み込みは続行する。
    }
    window.location.replace(`/?recovered=${Date.now()}`)
  }

  render() {
    if (!this.state.hasError) return this.props.children

    return (
      <main className="boot-screen boot-screen--error">
        <div className="brand-mark brand-mark--large">ALCO LOG</div>
        <h1>画面の読み込みに失敗しました</h1>
        <p>Safariに残った古い体験データが影響している可能性があります。</p>
        <button type="button" className="button button--primary" onClick={this.resetDemoData}>体験データを初期化して再読み込み</button>
        <button type="button" className="button button--secondary" onClick={() => window.location.reload()}>そのまま再読み込み</button>
      </main>
    )
  }
}
